import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calculator, ShieldCheck, FileText, HeartHandshake, Clock, ArrowUpRight, Users2 } from "lucide-react";
import { api } from "@/lib/api";

const MODULE_META = {
  rc: { label: "RC", icon: Calculator, color: "#10B981" },
  cau: { label: "Cauzioni", icon: ShieldCheck, color: "#F97316" },
  mup: { label: "MUP", icon: FileText, color: "#1B2380" },
  mrv: { label: "Multirischi Vol.", icon: HeartHandshake, color: "#DC2626" },
};

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short" }) : "—");
const fmtEuro = (n) => (n == null ? null : `€ ${Number(n).toLocaleString("it-IT", { maximumFractionDigits: 0 })}`);

function Tag({ module }) {
  const m = MODULE_META[module];
  if (!m) return null;
  const Icon = m.icon;
  return (
    <span className="inline-flex items-center gap-1 text-[10px] font-medium px-1.5 py-0.5 rounded-full"
      style={{ backgroundColor: `${m.color}1A`, color: m.color }}>
      <Icon className="h-2.5 w-2.5" /> {m.label}
    </span>
  );
}

export default function RecentActivityPanel() {
  const nav = useNavigate();
  const [recent, setRecent] = useState(null);

  useEffect(() => {
    api.get("/hub/overview").then((r) => setRecent(r.data.recent || [])).catch(() => setRecent([]));
  }, []);

  return (
    <div className="rounded-xl bg-white border border-slate-200 overflow-hidden lg:sticky lg:top-6" data-testid="hub-recent-panel">
      <div className="px-4 py-3 border-b border-slate-200 flex items-center gap-2 bg-slate-50/60">
        <Clock className="h-4 w-4 text-slate-400" />
        <h2 className="text-sm font-medium text-slate-700">Attività recente</h2>
        <span className="text-[10px] text-slate-400 ml-auto">tutti i moduli</span>
      </div>
      <div className="divide-y divide-slate-100 max-h-[calc(100vh-11rem)] overflow-y-auto" data-testid="hub-recent-list">
        {!recent && <div className="px-4 py-8 text-center text-slate-400 text-sm">Caricamento…</div>}
        {recent && recent.length === 0 && (
          <div className="px-4 py-10 text-center text-slate-400 text-sm">
            <Users2 className="mx-auto h-7 w-7 text-slate-300 mb-2" />
            Nessuna attività recente.
          </div>
        )}
        {(recent || []).map((it) => (
          <button key={`${it.module}-${it.id ?? it.subtitle}`} data-testid={`hub-recent-${it.module}-${it.id}`}
            onClick={() => nav(it.link)}
            className="group w-full text-left px-4 py-3 hover:bg-slate-50 transition-colors">
            <div className="flex items-center justify-between gap-2 mb-1">
              <Tag module={it.module} />
              <span className="text-[11px] text-slate-400 shrink-0">{fmtDate(it.date)}</span>
            </div>
            <div className="flex items-start gap-2">
              <div className="flex-1 min-w-0">
                <div className="font-medium text-slate-800 truncate text-sm">{it.title}</div>
                <div className="text-xs text-slate-400 truncate">{it.subtitle}</div>
              </div>
              <ArrowUpRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-brand-blue shrink-0 mt-0.5" />
            </div>
            <div className="flex items-center justify-between mt-1.5">
              <span className="text-[11px] text-slate-500">{it.status_label}</span>
              {fmtEuro(it.amount) && <span className="text-[11px] text-slate-600 tabular-nums font-medium">{fmtEuro(it.amount)}</span>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
